import { useEffect, useRef } from 'react';
import { GALLERY_ITEMS, BUSINESS_INFO } from '../data';
import SectionHeader from './SectionHeader';
import { useLang } from '../context/LangContext';

export default function Gallery() {
  const { t } = useLang();
  const gridRef = useRef(null);

  useEffect(() => {
    const el = gridRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        el.querySelectorAll('.reveal-clip').forEach((c, i) => {
          setTimeout(() => c.classList.add('visible'), i * 100);
        });
        obs.unobserve(el);
      }
    }, { threshold: 0.06 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section id="gallery" style={{ backgroundColor: 'var(--bg-alt)', padding: '9rem 0' }}>
      <div className="container">
        <SectionHeader
          tag={t.galleryTag}
          title={<>{t.galleryTitle} <em style={{ fontStyle: 'italic', fontWeight: 300 }}>{t.galleryTitleEm}</em></>}
          desc={t.galleryDesc}
          id="gallery-heading"
        />

        <div ref={gridRef} className="gallery-grid" style={{ marginTop: '3.5rem' }}>
          {GALLERY_ITEMS.map((item, index) => (
            <a
              key={item.id}
              href={BUSINESS_INFO.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className={`reveal-clip img-overlay ${item.tall ? 'gallery-item-tall' : ''}`}
              style={{
                display: 'block',
                textDecoration: 'none',
                borderRadius: '16px',
                overflow: 'hidden',
              }}
            >
              <img src={item.image} alt={item.alt} loading="lazy" />

              {/* Hover overlay */}
              <div style={{
                position: 'absolute', inset: 0, zIndex: 2,
                display: 'flex', flexDirection: 'column',
                justifyContent: 'flex-end', padding: '1.5rem',
              }}>
                <div className="heading-sub" style={{
                  color: 'rgba(232,180,184,0.9)',
                  fontSize: '0.62rem', marginBottom: '0.5rem',
                  transform: 'translateY(8px)',
                  transition: 'transform 0.4s cubic-bezier(0.25,1,0.5,1), opacity 0.4s',
                  opacity: 0,
                }}
                  onMouseOver={() => {}}
                >
                  {item.label}
                </div>
                <div style={{
                  fontFamily: 'var(--font-serif)',
                  fontSize: '1.1rem', color: '#fff', fontWeight: 400,
                }}>
                  {item.name}
                </div>
              </div>

              {/* Label badge */}
              <div style={{
                position: 'absolute', top: '1rem', left: '1rem', zIndex: 3,
              }}>
                <span className="badge" style={{
                  background: 'rgba(255,255,255,0.12)',
                  border: '1px solid rgba(255,255,255,0.25)',
                  backdropFilter: 'blur(8px)',
                  color: '#fff',
                  fontSize: '0.62rem',
                }}>
                  {item.label}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
